import { resetErrorBlock, showErrorsAtTop } from "./helpers";

/**
 * Handles form submission for document selection.
 * Collects selected documents, validates the form, and submits data to the server.
 *
 * @function getSelectedDocsOnSubmit
 */

export function getSelectedDocsOnSubmit() {
  const $saveButton = $(".js-def-document-save");
  const $docCards = $(".js-doc-card");
  const $form = $("form");
  const $selectedDocsInput = $("#SelectedDocuments");
  const saveUrl = "/Application/SaveDocumentSelection";

  $saveButton.on("click", async (e) => {
    e.preventDefault();

    try {
      // get an instance of the already initialised validator
      const formValidationObj = $form.data("validator");

      if (!formValidationObj.form()) {
        return;
      }
      $saveButton.prop("disabled", true).val("Saving...");
      // map through document cards and collect selected documents
      const selectedDocuments = $docCards
        .map(function () {
          const $section = $(this);
          const copies = parseInt($section.find(".js-copy-count").val(), 10);
          const agreedToTerms = $section
            .find(".js-terms-checkbox")
            .is(":checked");
          const documentId = $section.data("doc-cat");

          // skip if no copies selected
          if (!copies || copies <= 0) return null;

          // collect selected level checkboxes
          const levels = {};
          $section.find(".js-level-checkbox:checked").each(function () {
            const levelId = this.id.split("-")[0];
            levels[levelId] = true;
          });

          // return document data structure
          return {
            DocumentId: documentId,
            NumberOfCopies: copies,
            AgreedToTerms: agreedToTerms,
            Levels: levels,
          };
        })
        .get();

      // validate at least one document is selected
      if (selectedDocuments.length === 0) {
        showErrorsAtTop("Please select at least one document before saving.");
        return;
      }

      // store selected documents in hidden input
      $selectedDocsInput.val(JSON.stringify(selectedDocuments));
      const formData = $form.serialize(); // includes SelectedDocuments + other fields

      // submit form data to server
      const response = await $.ajax({
        url: saveUrl,
        method: "POST",
        data: formData,
      });

      if (response.success && response.id) {
        const nextPageURL = `/Application/YourDetails?id=${response.id}`;
        window.location.href = nextPageURL;
      } else {
        showErrorsAtTop(response.message);
      }
    } catch (err) {
      console.error("Error saving documents:", err);

      if (err.responseText) {
        console.error("Server response:", err.responseText);
      }
      showErrorsAtTop(
        "An unexpected error occurred while saving. Please try again later."
      );
    } finally {
      // re-enable button regardless of outcome
      $saveButton.prop("disabled", false).val("Save & continue");
    }
  });
}

/**
 * Resets all checkboxes in a group to unchecked state.
 *
 * @function resetCheckboxes
 * @param {jQuery} $cbGroup - jQuery collection of checkbox elements to reset.
 */

function resetCheckboxes($cbGroup) {
  $cbGroup.each(function () {
    $(this).prop("checked", false);
  });
}

/**
 * Resets level and terms checkboxes within a document card when the copy count is zero.
 *
 * @function resetOtherInputsWhenValIsZero
 * @param {jQuery} $card - jQuery object for the document card.
 * @param {jQuery} $cbWrap - jQuery object for the terms checkbox wrapper.
 */

function resetOtherInputsWhenValIsZero($card, $cbWrap) {
  const $levelCheckboxes = $card.find(".js-level-checkbox");
  const $termsCheckboxes = $cbWrap.find(".js-terms-checkbox");
  resetCheckboxes($levelCheckboxes);
  resetCheckboxes($termsCheckboxes);
}

/**
 * Shows or hides the Terms and Conditions checkbox based on the copy count.
 * Also highlights or unhighlights the document card and resets inputs if needed.
 *
 * @function showHideTandCCheckbox
 * @param {jQuery} $el - jQuery object for the copy count input element.
 * @param {number} count - The current number of copies selected.
 */

function showHideTandCCheckbox($el, count) {
  const $closestCard = $el.closest(".js-doc-card");
  const $closestTnadCCheckboxWrap = $closestCard.find(
    ".js-terms-checkbox-wrap"
  );

  if (count > 0) {
    $closestTnadCCheckboxWrap.slideDown(300);
    highlightDocCardIfSelected($closestCard, "add");
  } else {
    $closestTnadCCheckboxWrap.slideUp(300);
    highlightDocCardIfSelected($closestCard, "remove");
    resetOtherInputsWhenValIsZero($closestCard, $closestTnadCCheckboxWrap);
  }
}

/**
 * Adds or removes the 'doc-card--selected' class on a document card.
 *
 * @function highlightDocCardIfSelected
 * @param {jQuery} $el - jQuery object for the document card.
 * @param {string} action - Either "add" or "remove" to control the class.
 */

function highlightDocCardIfSelected($el, action) {
  $el[action + "Class"]("doc-card--selected");
}

/**
 * Resets validation errors for level checkboxes if the copy count is less than 1.
 *
 * @function resetLevelErrorsWhenValIsZero
 * @param {number} count - The current number of copies selected.
 */

function resetLevelErrorsWhenValIsZero(count) {
  if (count < 1) {
    $(".js-main-form").validate().resetForm();
  }
}

/**
 * Handles increment and decrement of document copy counts.
 * Updates UI and resets errors as needed.
 *
 * @function changeNoOfDocs
 */

export function changeNoOfDocs() {
  const $incDecBtn = $(".js-count-btn");

  $incDecBtn.on("click", function () {
    resetErrorBlock();
    const $closestInputGroup = $(this).closest(".input-group");
    const $closestCopyInput = $closestInputGroup.find(".js-copy-count");
    const $closestCopySrOnlyEl = $closestInputGroup.find(".js-copy-count-a11y");

    let copyCount = parseInt($closestCopyInput.val(), 10);
    const maxCopies = $closestCopyInput.data("max-copies");

    if ($(this).hasClass("increment") && copyCount < maxCopies) {
      copyCount++;
      $closestCopyInput.val(copyCount);
      $closestCopySrOnlyEl.text(copyCount);
      showHideTandCCheckbox($closestCopyInput, copyCount);
    }

    if ($(this).hasClass("decrement") && copyCount > 0) {
      copyCount--;
      $closestCopyInput.val(copyCount);
      $closestCopySrOnlyEl.text(copyCount);
      showHideTandCCheckbox($closestCopyInput, copyCount);
      resetLevelErrorsWhenValIsZero(copyCount);
    }
  });
}

/**
 * On page load, checks the copy count for each document and shows/hides the Terms and Conditions checkbox accordingly.
 *
 * @function checkSelectedBoxesOnLoad
 */

export function checkSelectedBoxesOnLoad() {
  const $countElements = $(".js-copy-count");
  $countElements.each(function (i) {
    const $element = $(this);
    const value = parseInt($(this).val(), 10);
    showHideTandCCheckbox($element, value);
  });
}
